import { makeStyles } from '@material-ui/styles'
import Theme from '@refera/ui-core'

const useStyles = makeStyles(() => ({
  tableContainer: {
    flex: 1,
    margin: '24px 2% 0 34px',
  },
  mainTable: {
    marginTop: '16px',
    width: 'auto',
    height: '650px',
  },
  emptyScreenWrapper: {
    height: '65vh',
  },
}))

export const datagridStyle = {
  fontSize: Theme.Typography.FontSize.XXSmall,
  '& .MuiDataGrid-cell:hover': {
    cursor: 'pointer',
  },
  '& .MuiDataGrid-cell[data-field="viewRequests"]': {
    color: '#1976d2',
    textDecoration: 'underline',
    '&:hover': {
      backgroundColor: 'rgba(25, 118, 210, 0.04)',
    },
  },
}

export default useStyles
